import PurchaseVideo from 'component/PurchaseVideo'
import useHintModal from './useHintModal'
import { useCallback } from 'react'

interface UseOpenPurchaseVideoModalParams {
  videoInfo: any
  type?: any
}

export const useOpenPurchaseVideoModal = ({ videoInfo, type }: UseOpenPurchaseVideoModalParams): (() => void) => {
  const { openHintModal } = useHintModal()
  const openPurchaseVideoModal = useCallback(() => {
    openHintModal({
      children: PurchaseVideo,
      props: {
        videoInfo,
        type,
      },
    })
  }, [openHintModal, videoInfo, type])
  return openPurchaseVideoModal
}
